// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Currency from '../_raw/ui/icon_currency.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Currency);
